let arr=[
    {name:'执行中',value:'执行中'},
    {name:'已完成',value:'已完成'}
]
export default arr